export default "__VITE_ASSET__ea04d6aa__"